<template>
  <div class="position-relative">
    <loader color="grey" v-if="loading"/>

    <help :text="$t('help.cascade_access')" :title="$t('help.cascade_access_title')"/>

    <div class="white-container">
      <b-row>
        <b-col>
          <b-button
              class="px-4 mb-3"
              @click="() => {$bus.$emit('openCascadeAccessModal')}">
            {{ $t('cascade_access.add_cascade_access') }}
          </b-button>
        </b-col>
        <b-col cols="3">
          <multiselect
              v-model="selectedAccessType"
              label="label"
              track-by="value"
              :placeholder="$t('cascade_access.select_type')"
              :options="optionsAccessType"
              @select="onSelectedAccessType"
              :searchable="false"
              :close-on-select="true"
              :allow-empty="false"
              select-label=""
              selected-label=""
              deselect-label="X"
          />
        </b-col>
      </b-row>
      <div style="min-height: 100px">
        <b-row v-for="(item, index) in cascadeAccesses" :key="index"
               v-if="!loading">
          <b-col>
            <div class="mt-2">
              <b-card no-body class="mb-1 border-0">
                <b-card-header
                    header-tag="header"
                    class="py-3 px-4 pointer border-0"
                    role="tab"
                    v-b-toggle="'cascade-access-' + index">
                  <div
                      class="d-flex flex-row justify-content-between align-items-center">
                    <div>
                      <b-row>
                        <b-col>
                          <i class="fas fa-sort-down mr-3"></i>
                          <span>Resource: {{ item.resource.title }}</span>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <small class="text-muted ml-4">
                            {{ $t('cascade_access.type') }}:
                            {{ getCascadeAccessType(item) }}
                          </small>
                        </b-col>
                      </b-row>
                    </div>
                    <div
                        class="col-md-10 col-lg-8 col-xl-6 d-flex flex-row justify-content-between align-items-center">
                      <div>
                        <div v-if="item.subscription_id">
                          <b-row>
                            <b-col>
                            <span class="mr-2">
                              Plan: <b>{{ item.subscription.plan.title }}</b>
                            </span>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col>
                            <span class="mr-2">
                              Subscription: <b>{{
                                item.subscription.plan.title
                              }}</b>
                            </span>
                            </b-col>
                          </b-row>
                        </div>

                        <div v-if="item.ti_event_ticket_id">
                          <b-row>
                            <b-col>
                            <span class="mr-2">
                              Event: <b>{{
                                item.ti_event_ticket.ti_event.title
                              }}</b>
                            </span>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col>
                            <span class="mr-2">
                              Ticket: <b>{{ item.ti_event_ticket.title }}</b>
                            </span>
                            </b-col>
                          </b-row>
                        </div>

                        <div v-if="item.content_id">
                          <b-row>
                            <b-col>
                            <span class="mr-2">
                              Content: <b>{{ item.content.title }}</b>
                            </span>
                            </b-col>
                          </b-row>
                        </div>

                      </div>
                      <div>
                        <b-badge
                            :variant="item.active ? 'success': 'info'"
                            class="text-white ml-2 font-weight-light"
                            style="font-size: 12px">
                          {{
                            item.active ? $t('form.active') : $t('form.inactive')
                          }}
                        </b-badge>
                      </div>
                    </div>

                  </div>
                </b-card-header>
                <b-collapse :id="'cascade-access-'+index"
                            accordion="cascade-accesses-accordion"
                            role="tabpanel"
                            @show="onToggleCollapse(index, true)"
                            @hidden="onToggleCollapse(index, false)"
                >

                  <b-card-body
                      class="position-relative d-flex flex-column pt-3 px-4 pb-0">
                    <div class="position-relative">
                      <b-row>
                        <applied-cascade-access-view
                            v-if="item.shouldRender"
                            :cascade-access="item"
                            :partner-id="partnerId"
                            :resource-key="item.resource.key"
                            :partner-resources="partnerResources"/>

                        <excluded-cascade-access-view
                            v-if="item.shouldRender"
                            :cascade-access="item"
                            :partner-id="partnerId"
                            :resource-key="item.resource.key"
                            :partner-resources="partnerResources"/>
                      </b-row>
                    </div>


                    <b-row>
                      <b-col
                          class="d-flex align-items-center justify-content-end">
                        <label class="mr-2"
                               :for="`active-${item.active}`">Active
                        </label>
                        <div class="mr-4">
                          <label
                              class="switch switch-3d switch-success mb-0">
                            <b-form-checkbox type="checkbox"
                                             @change="updateCascadeAccess(item)"
                                             class="switch-input"
                                             v-model="item.active"
                            />
                            <input type="checkbox"
                                   class="switch-input"
                                   :checked="item.active"
                            >
                            <span class="switch-slider"></span>
                          </label>
                        </div>
                        <b-btn
                            class="align-self-center p-0 mb-2"
                            @click="onDelete(item.id)"
                            variant="link">
                          <u class="text-secondary">{{
                              $t('button.delete')
                            }}</u>
                        </b-btn>
                      </b-col>
                    </b-row>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>

    <cascade-access-modal v-if="partnerId" :partner-id="partnerId"/>
    <applied-cascade-access-modal
        :key="appliedCascadeAccessId"
        v-if="appliedAccessType && partnerId && ((action === 'create' &&
        targetCascadeAccessId) ||
         (action === 'update' && appliedCascadeAccessId))"
        :cascade-access-id="targetCascadeAccessId"
        :used-resources="usedResources"
        :action="action"
        :type="appliedAccessType"
        :applied-access-item="appliedAccessItem"
        :on-cancel-callback="clearExcludedCascadeAccessModalData"
        :partner-id="partnerId"/>
    <excluded-cascade-access-modal
        :key="excludedCascadeAccessId"
        v-if="excludedAccessType && partnerId && ((action === 'create' &&
        targetCascadeAccessId) ||
         (action === 'update' && excludedCascadeAccessId))"
        :cascade-access-id="targetCascadeAccessId"
        :used-resources="usedResources"
        :action="action"
        :type="excludedAccessType"
        :excluded-access-item="excludedAccessItem"
        :on-cancel-callback="clearAppliedCascadeAccessModalData"
        :partner-id="partnerId"/>

    <modal :show-modal="showDeleteModal"
           :title="$t('cascade_access.delete_message')"
           @cancel="cancelDelete"
           @ok="deleteCascadeAccess"
           @hide="cancelDelete"/>

  </div>
</template>

<script>

import i18n from "@/utils/i18n";
import GroupSelect from "@/components/global/groupSelect";
import CascadeAccessModal from "./CascadeAccessModal";
import AppliedCascadeAccessModal from "./AppliedCascadeAccessModal";
import ExcludedCascadeAccessModal from "./ExcludedCascadeAccessModal";
import AppliedCascadeAccessView from "./AppliedCascadeAccessView";
import ExcludedCascadeAccessView from "./ExcludedCascadeAccessView";
import {find, get, isUndefined, map} from "lodash";

const typeOptions = [
  {label: i18n.t('cascade_access.type_all'), value: ""},
  {label: i18n.t('cascade_access.type_subscription'), value: "plans"},
  {label: i18n.t('cascade_access.type_ticket'), value: "ti_events"},
  {label: i18n.t('cascade_access.type_content'), value: "content"},
]

export default {
  name: "CascadeAccessView",
  components: {
    GroupSelect,
    CascadeAccessModal,
    AppliedCascadeAccessView,
    AppliedCascadeAccessModal,
    ExcludedCascadeAccessView,
    ExcludedCascadeAccessModal,
  },
  data() {
    return {
      cascadeAccesses: [],
      showDeleteModal: false,
      loading: false,
      deleteCascadeAccessId: null,
      partnerId: null,
      partnerResources: [],
      loadingPartnerResources: false,
      usedResources: [],
      targetCascadeAccessId: null,
      appliedCascadeAccessId: null,
      excludedCascadeAccessId: null,
      appliedAccessItem: null,
      excludedAccessItem: null,
      appliedAccessType: null,
      excludedAccessType: null,
      accessType: null,
      selectedAccessType: null,
      optionsAccessType: typeOptions,
      action: null
    }
  },
  created() {

    const queryType = get(this, '$route.query.type', '');
    const typeValues = map(typeOptions, 'value');
    const type = typeValues.includes(queryType) ? queryType : '';
    this.selectedAccessType = find(typeOptions, {value: type});

    this.getAllData();
  },
  mounted() {
    this.$bus.$on('reloadCascadeAccesses', () => {
      this.getAllData();
    });

    this.$bus.$on('openCreateAppliedCascadeAccess', (params, type) => {
      this.openAppliedCascadeAccessModal(params, type, 'create');
    });

    this.$bus.$on('openUpdateAppliedCascadeAccess', (params, type) => {
      this.openAppliedCascadeAccessModal(params, type, 'update');
    });

    this.$bus.$on('openCreateExcludedCascadeAccess', (params, type) => {
      this.openExcludedCascadeAccessModal(params, type, 'create');
    });

    this.$bus.$on('openUpdateExcludedCascadeAccess', (params, type) => {
      this.openExcludedCascadeAccessModal(params, type, 'update');
    });
  },
  destroyed() {
    this.$bus.$off(`reloadCascadeAccesses`);
    this.$bus.$off(`openCreateAppliedCascadeAccess`);
    this.$bus.$off(`openUpdateAppliedCascadeAccess`);
    this.$bus.$off(`openCreateExcludedCascadeAccess`);
    this.$bus.$off(`openUpdateExcludedCascadeAccess`);
  },
  methods: {
    async getAllData() {
      this.loading = true;
      try {
        await this.getResourceSettings();
        await this.getCascadeAccesses();
      } catch (error) {
        if (error && error.response) {
          this.$noty.error(error.response.data.error_description);
        }
      } finally {
        this.loading = false
      }
    },
    async getResourceSettings() {
      return this.getData(`resources/${this.$store.getters['resource/currentResource'].key}`)
          .then(({data}) => {
            if (data.partner_id) {
              this.partnerId = data.partner_id;
            }
          }).catch((error) => {
            if (error && error.response) {
              this.$noty.error(error.response.data.error_description);
            }
          });
    },
    async getCascadeAccesses() {
      let params = {};
      const type = this.selectedAccessType.value;
      if (type) {
        params.type = type;
      }
      return this.getData(`partners/${this.partnerId}/cascade-accesses`,
          {params})
          .then(({data}) => {
            if (Array.isArray(data.items)) {
              this.cascadeAccesses = data.items;
            }
          })
          .catch(error => {
            if (error && error.response) {
              this.$noty.error(error.response.data.error_description);
            }
          })
    },
    onDelete(id) {
      this.showDeleteModal = true;
      this.deleteCascadeAccessId = id;
    },
    cancelDelete() {
      this.showDeleteModal = false;
      this.deleteCascadeAccessId = null;
    },
    deleteCascadeAccess() {
      this.loading = true
      this.deleteData(`partners/${this.partnerId}/cascade-access/${this.deleteCascadeAccessId}`)
          .then(() => {
            this.deleteCascadeAccessId = null;
            this.showDeleteModal = false;
            this.getAllData();
          })
          .catch(error => {
            if (error && error.response) {
              this.$noty.error(error.response.data.error_description);
            }
            this.loading = false
          })
    },
    getCascadeAccessType(item) {
      if (item.subscription_id) return i18n.t('cascade_access.type_subscription')
      if (item.ti_event_ticket_id) return i18n.t('cascade_access.type_ticket')
      if (item.content_id) return i18n.t('cascade_access.type_content')
    },
    onToggleCollapse(index, val) {
      const targetCascadeAccess = {...this.cascadeAccesses[index]};
      targetCascadeAccess.shouldRender = val;
      this.$set(this.cascadeAccesses, index, targetCascadeAccess);
      if (val) {
        this.targetCascadeAccessId = targetCascadeAccess.id;
      }
    },
    shouldRender(item) {
      return !isUndefined(item.shouldRender) && item.shouldRender === true;
    },
    clearAppliedCascadeAccessModalData() {
      this.usedResources = [];
      this.appliedAccessItem = null;
      this.appliedCascadeAccessId = null;
      this.action = null;
    },
    clearExcludedCascadeAccessModalData() {
      this.usedResources = [];
      this.excludedAccessItem = null;
      this.excludedCascadeAccessId = null;
      this.action = null;
    },
    openAppliedCascadeAccessModal(params, type, action) {
      this.usedResources = get(params, 'usedResources', []);
      this.appliedAccessItem = get(params, 'appliedAccessItem', null);
      this.appliedCascadeAccessId = get(params, 'appliedAccessItem.id', null);
      this.appliedAccessType = type;
      this.action = action;
      this.$nextTick(() => {
        this.$bus.$emit('openAppliedCascadeAccessModal')
      });
    },
    openExcludedCascadeAccessModal(params, type, action) {
      this.usedResources = get(params, 'usedResources', []);
      this.excludedAccessItem = get(params, 'excludedAccessItem', null);
      this.excludedCascadeAccessId = get(params, 'excludedAccessItem.id', null);
      this.excludedAccessType = type;
      this.action = action;
      this.$nextTick(() => {
        this.$bus.$emit('openExcludedCascadeAccessModal')
      });
    },
    updateCascadeAccess(cascadeAccess) {
      const source = {
        active: cascadeAccess.active
      }
      if (cascadeAccess.subscription_id) {
        source.subscription_id = cascadeAccess.subscription_id
      }
      if (cascadeAccess.ti_event_ticket_id) {
        source.ti_event_ticket_id = cascadeAccess.ti_event_ticket_id
      }
      if (cascadeAccess.content_id) {
        source.content_id = cascadeAccess.content_id
      }

      this.putData(`partners/${this.partnerId}/cascade-access/${cascadeAccess.id}`,
          {...source})
          .catch(error => {
            if (error && error.response) {
              this.$noty.error(error.response.data.error_description);
            }
          })
    },
    onSelectedAccessType(selectedAccessType) {
      const type = get(selectedAccessType, 'value', '');
      const query = type === '' ? null : {type: type}
      this.$router.replace({
        path: this.$route.path,
        query: query
      });
      this.getAllData();
    }
  },
}
</script>
